import dayjs from 'dayjs'

const opcoes = () =>
    [
        {
            label: 'DSR Automático',
            value: '-2',
        },
        {
            label: 'DSR variável',
            value: '-1',
        },
    ].concat(
        Array.from({ length: 7 }).map((_, i) => ({
            value: i.toString(),
            label: dayjs()
                .day(i)
                .format('dddd')
                .replace(/^\w/, c => c.toUpperCase()),
        })),
    )

export default opcoes
